import { useEffect, useState } from 'react';
import { getDetectionSettings, getVendorFeatures, getVendorId, isSupervisor } from '../api/client';

export const DEFAULT_DETECTION_SETTINGS = {
  drowsiness: { enabled: true, sensitivity: 5 },
  yawning: { enabled: true, sensitivity: 5 },
  distracted: { enabled: true, sensitivity: 5 },
  presence: { enabled: true, sensitivity: 5, away_threshold_minutes: 3,
              auto_close_at_shift_end: true },
  // Work Activity Monitoring features have no sensitivity/supervisor
  // detection-settings concept — only the vendor license (below) masks
  // them. Included here so the same enabled()/DEFAULT_DETECTION_SETTINGS
  // contract used for nav/filter/page visibility across the app also
  // covers Screenshot/Browser History, instead of a second parallel
  // "is this feature on" mechanism.
  screenshot: { enabled: true },
  browser_history: { enabled: true },
};

const ALL_FEATURE_KEYS = ['drowsiness', 'yawning', 'distracted', 'presence', 'screenshot', 'browser_history'];

export default function useDetectionSettings() {
  const [settings, setSettings] = useState(DEFAULT_DETECTION_SETTINGS);
  useEffect(() => {
    const vendorId = getVendorId();
    const featureRequest = vendorId ? getVendorFeatures(vendorId).then(features => {
      setSettings(current => {
        const next = { ...current };
        for (const key of ALL_FEATURE_KEYS) {
          if (next[key]) next[key] = { ...next[key], enabled: Boolean(features[key]) && next[key].enabled };
        }
        return next;
      });
    }) : Promise.resolve();
    const settingsRequest = isSupervisor()
      ? getDetectionSettings().then(data => setSettings(current => {
          const next = { ...current };
          for (const key of ['drowsiness', 'yawning', 'distracted', 'presence']) {
            if (data[key]) next[key] = { ...data[key], enabled: Boolean(data[key].enabled) && next[key].enabled };
          }
          return next;
        }))
      : Promise.resolve();
    Promise.allSettled([featureRequest, settingsRequest]);
  }, []);
  return settings;
}

export const enabled = (settings, type) => settings[type]?.enabled !== false;
